export const TAX_CARD_FIXED = 'TAX_CARD_FIXED';
export const TAX_CARD_SAVING = 'TAX_CARD_SAVING';
export const TAX_CARD_EDIT = 'TAX_CARD_EDIT';
export const TAX_CARD_CREATE = 'TAX_CARD_CREATE';

export const ACCOUNT_EDIT = 'ACCOUNT_EDIT';
export const ACCOUNT_SAVING = 'ACCOUNT_SAVING';
export const ACCOUNT_FIXED = 'ACCOUNT_FIXED';



// WEBPACK FOOTER //
// ./src/constants/statuses.js